import {put, takeEvery} from 'redux-saga/effects';

import {selectApplication} from 'modules/applications/actions';
import {setSendSnapshot} from 'modules/a11ycat/actions';


export default function* () {
    yield takeEvery(selectApplication, disableA11ycat)
}

function* disableA11ycat() {
    yield put(setSendSnapshot(false));
}